import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerList: [],
      timeZone: [],
      roles: [],
      customerID: "default",
      customerName: "",
      time: "default",
      timeZoneId: "",
      name: "",
      description: "",
      role: "User",
      email: "",
      password: "",
      confpassword: "",
      realTimeValidation: true,
      realTimeUserValidation: true,
      customerID_error: false,
      time_error: false,
      name_error: false,
      role_error: false,
      email_error: false,
      emailformat_error: false,
      password_error: false,
      passwordlength_error: false,
      confpassword_error: false,
    };
    this.formSubmit = false;
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({
        customerName: values.selectedAsset,
        customerID: values.customerId,
      });
    }
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const customerList = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ customerList: customerList.data });
      console.log("customer id", customerList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    //Get all Time zone
    this.props.setLoadingPageAction(true);

    try {
      const timeZone = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ timeZone: timeZone.data });
      console.log("timeZone ", timeZone.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    //Get all Roles
    this.props.setLoadingPageAction(true);

    try {
      const roles = await axios.get(`${apiHost}/api/auth/AllRoles`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      roles.data.sort((a,b) => {
        if(a.roleName.toLowerCase() > b.roleName.toLowerCase()){
          return -1;
        }
        else if(a.roleName.toLowerCase() < b.roleName.toLowerCase()){
          return 1;
        }
       else{
          return 0;
        }
      })
      this.setState({ roles: roles.data });
      console.log("timeZone ", roles.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  handleCustomeridChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ customerID_error: true });
    } else {
      this.setState({ customerID_error: false });
    }
    this.setState({ customerID: e.target.value });
  }
  handleTimeChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ time_error: true });
    } else {
      this.setState({ time_error: false });
    }
    this.state.timeZone.forEach((time) => {
      if (time.timeZoneCity == e.target.value) {
        this.setState({ timeZoneId: time.timeZonesId });
      }
    });
    this.setState({ time: e.target.value });
  }
  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleRoleChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({ role_error: true });
    } else {
      this.setState({ role_error: false });
    }
    this.setState({ role: e.target.value });
  }
  handleEmailChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      // this.setState({emailformat_error:false})
      this.setState({ email_error: true });
    } else if (!e.target.value.match(mailformat)) {
      // this.setState({emailformat_error:true})
      this.setState({ email_error: false });
    } else {
      // this.setState({emailformat_error:false})
    }
    this.setState({ email: e.target.value });
  }
  handleDescription = (e) => {
    console.log("e.target.value", e.target.value);
    this.setState({ description: e.target.value });
  };
  handlePasswordChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ passwordlength_error: false });

      this.setState({ password_error: true });
    } else if (e.target.value.length < 6 || e.target.value.length > 30) {
      this.setState({ password_error: false });
      this.setState({ passwordlength_error: true });
    } else {
      this.setState({ passwordlength_error: false });
    }
    this.setState({ password: e.target.value });
  }
  handleConfirmPasswordChange(e) {
    if (e.target.value !== this.state.password) {
      this.setState({ confpassword_error: true });
    } else {
      this.setState({
        confpassword_error: false,
        confpassword: e.target.value,
      });
    }
  }
  async handleSubmit() {
    console.log("clicked");
    this.formSubmit = true;

    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }
    if (this.state.time == "default") {
      this.setState({ time_error: true });
      this.formSubmit = false;
    }
    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.role == "default") {
      this.setState({ role_error: true });
      this.formSubmit = false;
    }
    if (this.state.email == "") {
      this.setState({ email_error: true });
      this.formSubmit = false;
    } else if (!this.state.realTimeValidation) {
      this.formSubmit = false;
    }
    if (this.state.password == "") {
      this.setState({ password_error: true });
      this.formSubmit = false;
    } else if (this.state.confpassword == "") {
      this.setState({ confpassword_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/auth/register`,
          {
            Username: this.state.name,
            Description: this.state.description,
            Password: this.state.password,
            CustomerId: this.state.customerID,
            TimeZoneId: this.state.timeZoneId,
            Email: this.state.email,
            UserType: [this.state.role],
            DisplayName: this.state.name
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log("userrespo suces",response)
        // this.props.history.push("/users");

        this.props.history.goBack();
        console.log("customer id", response.data);
        this.props.setLoadingPageAction(false);
      }
      catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else if (e.response.status == "400") {
          for(var key in e.response.data.errors) {
            // console.log("userrespo",e.response.data.errors[key])
            alert(e.response.data.errors[key])

          }
          // this.props.history.push("/login");
        }else {
          if (e.response.data.statusCode == "1") {
            this.props.setErrorMessageAction("User Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
          // this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }

  realTimeUserValidation = async (e) => {
    try {
      let response = await axios.get(
        `${apiHost}/api/Auth/IsEmailExist?Email=${encodeURIComponent(e.target.value)}&userId=${encodeURIComponent("")}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("response", response.data);
      this.setState({ realTimeValidation: true });
    } catch (e) {
      this.setState({ realTimeValidation: false });

      console.log(
        `Axios request failed.Error logged on Realtime User Check${e}`
      );
    }
  };

  realTimeUserNameValidation = async (e) => {
    try {
      let response = await axios.get(
        `${apiHost}/api/Auth/IsUserExist?userName=${encodeURIComponent(e.target.value)}&userId=${""}`, 
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("response", response.data);
      this.setState({ realTimeUserValidation: true });
    } catch (e) {
      this.setState({ realTimeUserValidation: false });

      console.log(
        `Axios request failed.Error logged on Realtime User Check${e}`
      );
    }
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    console.log("roles", this.state.roles);
    var selectCustomerTag;
    if (values.selectedAsset) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
          value={this.state.customerID}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomeridChange.bind(this)}
        >
          <option value="default">Select Customer</option>
          {this.state.customerList.map((customer, index) => {
            return <option value={customer.id}>{customer.name}</option>;
          })}
        </Form.Control>
      );
    }
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create user </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Create User</h2>
              <h6>Create a new user</h6>
              <hr></hr>
              <Form>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> CustomerID</span>
                  </Form.Label>
                  <Col sm={10}>
                    {selectCustomerTag}
                    <p
                      style={
                        this.state.customerID_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Time Zone</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="select"
                      onChange={this.handleTimeChange.bind(this)}
                    >
                      <option value="default">Select Time Zone</option>
                      {this.state.timeZone.map((time, index) => {
                        return (
                          <option value={time.timeZoneId}>
                            {time.timeZoneCity}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <p
                      style={
                        this.state.time_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Time Zone field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Name</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      value={this.state.name}
                      onChange={this.handleNameChange.bind(this)}
                      onBlur={(e) => {
                        this.realTimeUserNameValidation(e);
                      }}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                    {this.state.userName != "" && (
                      <React.Fragment>
                        <p
                          style={
                            !this.state.realTimeUserValidation
                              ? { color: "#a94442", fontSize: "14px" }
                              : { display: "none" }
                          }
                        >
                          User already exist
                        </p>
                      </React.Fragment>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlaintextArea">
                  <Form.Label column sm="2">
                    <span style={{ float: "right" }}>Description</span>
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      as="textarea"
                      rows="3"
                      onChange={this.handleDescription}
                    />
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  controlId="exampleForm.HorizontalControlSelect1"
                >
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Role</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="select"
                      onChange={this.handleRoleChange.bind(this)}
                      value= {this.state.role}
                    >
                      {/* <option value="default">Select Role</option> */}
                      {this.state.roles.map((role, index) => {
                        return (
                          <option value={role.roleName}>{role.roleName}</option>
                        );
                      })}
                    </Form.Control>
                    <p
                      style={
                        this.state.role_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Role field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Email</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="email"
                      onChange={(e) => {
                        this.handleEmailChange(e);
                        this.realTimeUserValidation(e);
                      }}
                    />
                    <p
                      style={
                        this.state.email_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Email field is required.
                    </p>
                    {this.state.email != "" && (
                      <React.Fragment>
                        <p
                          style={
                            !this.state.realTimeValidation
                              ? { color: "#a94442", fontSize: "14px" }
                              : { display: "none" }
                          }
                        >
                          Username already in use
                        </p>
                      </React.Fragment>
                    )}
                    <p
                      style={
                        this.state.emailformat_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Email field is not a valid e-mail address.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Password</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handlePasswordChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.password_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Password field is required.
                    </p>
                    <p
                      style={
                        this.state.passwordlength_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Password restricted 6-30 characters long
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Confirm Password</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleConfirmPasswordChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.confpassword_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The password and confirmation password do not match.
                    </p>
                  </Col>
                </Form.Group>
                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      // this.props.history.push("/users");
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={!this.state.realTimeValidation || !this.state.realTimeUserValidation}
                  >
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
